// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunk." + {"core-gallery":"0e45db7afe05fdbf566b","dynamic-text":"b059432a566b96f4fe72","requestidlecallback-polyfill":"4dd2e35f8c00d63ec6b6"}[chunkId] + "." + chunkId + ".js";
};